module.exports = __webpack_public_path__ + "img/banner3.4481de48.jpg";